<template>
    <div class="notifications TQ_center" :style="{'zIndex': gv_zIndex.app_globalNotification}" :data-hook="DataHooks_o.notification_root">

        <div v-for="(notify, index) in p_notifications_a"
             class="TQ_Animation_smallBigSmall TQ_margin_2px"
             @click.stop="p_notifications_a.splice(index,1)">

            <div :class="co_screenSizeClass_o"
                :data-hook="DataHooks_o.notification_item"
                 class="lc_notification TQ_bg_purple_lite2 TQ_border TQ_borderRadius">
                <div class="title TQ_text_capitalize" v-if="notify.title" >{{notify.title[p_system_langCode_e] ? notify.title[p_system_langCode_e] : notify.title}}</div>
                <div v-if="notify.text">{{notify.text[p_system_langCode_e] ? notify.text[p_system_langCode_e] : notify.text}}</div>
                <div class="TQ_center">
                    <component :is="notify.component" :p_screenSize_e="p_screenSize_en" :p_systemLangCode_e="p_system_langCode_e"></component>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import si_unlock from '../../components/a_smartIcons/si_unlock'
    import si_clue from '../../components/a_smartIcons/si_clue'
    import Si_idea from "../../components/a_smartIcons/si_clue";
    import si_finishRiddle from "../../components/a_smartIcons/si_finishRiddle";
    import si_finishQuest from "../../components/a_smartIcons/si_finishQuest";
    import si_skip from "../../components/a_smartIcons/si_skip";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import {ass_img_closeRed} from "../../assets/scripts/Ass_Files";
    import {gv_zIndex} from "../../scripts/S_GlobalVar";
    import {enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
import { DataHooks_o } from '@/scripts/S_DataHooks';

    export default {
        name: "C_App_GlobalNotification",
        components: {Si_idea, si_unlock, si_skip, si_finishRiddle, si_clue, si_finishQuest},
        props:{
            p_notifications_a:{
                type: Array,
                require: true,
                default: () => {[]}
            },
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(val) {
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_screenSize_en:{
                type:Number,
                require: true,
                validator(val) {
                    return validator_enum_fb(enum_screenSizesOptions_n, val)
                }

            }
        },
        data(){
            return {
                ass_img_closeRed,
                gv_zIndex,
                DataHooks_o
            }
        },
        computed:{
            co_screenSizeClass_o(){
                return {
                    'lc_mobile' : this.p_screenSize_en === enum_screenSizesOptions_n.mobile,
                    'lc_tablet' : this.p_screenSize_en > enum_screenSizesOptions_n.mobile
                }
            },

        },


    }
</script>

<style scoped lang="scss">
    /* notification */
    .notifications{
        position: fixed;
        top: 50%;
        left: 0;
        width: 100%;
        transform: translate(0, -50%);


        .closeBtn{
            width: calc(100% - 14px);
            margin: -4px auto -22px;
            text-align: right;


            &.lc_mobile{
                max-width: 230px;
            }

            &.lc_tablet {
                max-width: 270px;
            }

        }


        .lc_notification{

            /* 0) all  */
            width: calc(100% - 48px);
            margin: 0 auto;
            padding: 8px;
            box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);


            &.lc_mobile{
                max-width: 200px;

                .title{
                    font-size: 18px;
                    font-weight: bold;
                }
            }

            &.lc_tablet{
                max-width: 240px;

                .title{
                    font-size: 24px;
                    margin-bottom: 4px;
                    font-weight: bold;
                }

            }



        }
    }
</style>